
export class Profile {
    public name: string
    public email: string
    public storeId: string
    public storeName: string
    public storeSeoName: string
    public storeInstagram: string
    public storeFacebook: string
    public ownerLinkedin: string
    public logo: string
    public domain: string
    public newDomain: string
    public apiKey: string
    public apiToken: string
    public category: string

    public hasPolenInvoice: boolean
    public activePayingUser: boolean
    public integrationActive: boolean
    public scriptValidated: boolean
    public trialActive: boolean
    public isValidApi: boolean
    public trialEndDate: string
    public daysTrialLeft: number //nao tem no banco

    public donationType: Number
    public donationRule: Number

    public donationValue: number
    public totalSales: Number
    public totalDonation: Number
    public maxUserDonation: Number
    public maxDonationPerMonth: Number
    public defaultUserDonation: Number

    public polenVisibility: Number

    public password: string

    public integrationType: number
    public platformInfo: PlatformInfo

    public commissionValue: number
    public monetizationType: number // fixprice = 0 / percentage = 1 / both = 2
    public donationMade: number // ByPolen = 0, ByStore = 1
    public paymentType: number// All-0 / CreditCar = 1 / Boleto = 2
    public paymentList: Array<number>// All-0 / CreditCar = 1 / Boleto = 2 / Pix=6
    public creditCardList: Array<CreditCardInfo>
    public invoices: Array<StoreStatement>

    public planName: string
    public planSeoName: string
    public planTypeId: string
    public planPrice: number
    public planPeriod: number
    public installment: number = 1 //parcelas caso pague no cartao em plano semestral/anual

    public statusStore: string

    public hasBillingInfos: boolean;
    public billingType: number;
    public billingName?: string;
    public billingIdentifier?: string;
    public billingAddress?: string;
    public billingAddressComplement?: string;
    public billingAddressNumber?: string;
    public billingNeighboor?: string;
    public billingZipCode?: string;
    public billingCity?: string;
    public billingCityCode?: string;
    public billingState?: string;

    public paymentSubscriptionId?: string;
    public paymentCompanyId?: string;

    public referralCode: string;
    public nextInvoiceDate: Date;
    public hasSubscription: boolean;
    public firstEmailSent: boolean;
    public isFirstTimeFromPlatform: boolean;

    public isOnboardingFirstPage: boolean;

    //iugu ou safe2pay
    public invoiceType: string;

    constructor() {
    }
}

export class CategoryStore {
    public id: string;
    public name: string;
    public isSelected: boolean;

}

export class ApiAccess {
    public platform: string
    public key: string
    public token: string
    public platformStoreName: string
    public isValidApi: string
    public storeSeoName: string
    public storeUrl: string
}

export class PlatformInfo {
    public id: string
    public name: string
    public seoName: string
    public platformJavascript: string
    public fullInstallation: boolean

    constructor() {
    }
}

export class PaymentInfo {
    storeName: string;
    createPaymentInvoice: boolean;
    id: string;
    method: string;
    extra_info: CreditCardInfo;
    test: boolean;
    isInstallment: boolean;
    planId: string
    addMoneyToBalance: boolean;
    prePaid: number;
}

export class CreditCardInfo {
    polenPaymentMethodId: string;
    default: boolean;
    brand: string;
    holder_name: string;
    display_number: string;
    bin: string;
    month: number;
    year: number;
    token: string;
    installment: number
    tokenize: boolean
}

export class FinanceInfoDTO {
    public statements: Array<StoreStatement>
    public monthFinance: Array<MonthFinanceDTO>
}

export class MonthFinanceDTO {
    month: Date
    revenue: number
    donation: Date
    mrr: number
    activeClients: number
    churnClients: number
    testClients: number
    statements: Array<StoreStatement>

    totalAvailable: number
    totalPolenAvailable: number
    totalDonationAvailable: number
    totalFuture: number
    totalPolenFuture: number
    totalDonationFuture: number

    totalPaid: number
    countPaid: number

    totalNotPaid: number
    totalPolenNotPaid: number
    totalDonationNotPaid: number
    countNotPaid: number

    countInvoices: number
}

export class StoreStatement {
    id: string;
    storeId: string;
    storeName: string;
    storeSeoName: string;
    storePlatformName: string;
    date: Date;
    fromDate: Date;
    toDate: Date;
    paymentAvailableDate: Date;
    totalDonationApproved: number;
    totalDonation: number;
    commissionPercentage: number;
    totalCommission: number;
    totalInvoice: number;
    totalRevenue: number;
    discount: number;
    notes: string;
    invoiceTaxes: number
    paymentList: any


    paid: boolean
    filterShow: boolean = true;

    //ngos: number;

    // 1 - aguardando pagamento
    // 2 - ecommerce pagou
    // 3 - Aguardando dados das Ongs
    // 4 - Ongs Receberam
    // 5 - Concluído - Ongs mandaram recibo
    statusStatement: number;
    polenSubscription: number;
    hasDonation: boolean;
    planTypeId: string;
    planSeoName?: any;
    invoiceType: number;
    invoiceDate: Date;
    paymentDate: Date;
    invoiceId: string;
    invoiceUrl: string;
    invoiceSent: boolean;
    invoiceError: string;
    planName: string;
    statusInvoice: string;
    taxStatementUrl: string;
    subItens: InvoiceSubItens[]

}

export class InvoiceSubItens {
    description: string;
    value: number;
}

export class StoreStatementManualDto {
    seoUrl: string;
    revenue: number
    mrr: number
    date: Date
    planSeoName: string
    discount: number
    commissionPercentage: number;
    hasDonation: boolean;
    oneTimePayment: boolean;
    ngos: Array<StoreStatementNgoManualDto>
}


export class StoreStatementNgoManualDto {
    ngoUrl: string;
    donation: number
}
